import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CreateEntityDocumentCategoryBody,
  EntityDocumentCategoryApi,
  FilterEntityDocumentCategoryOption,
  UpdateEntityDocumentCategoryBody,
} from 'api';

import { RootState } from '../app';

export const filterEntityDocumentCategory = createAsyncThunk(
  'entityDocumentCategory/filterEntityDocumentCategory',
  async (option: FilterEntityDocumentCategoryOption, { rejectWithValue }) => {
    try {
      const response = await EntityDocumentCategoryApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityDocumentCategoryWithEntity = createAsyncThunk(
  'entityDocumentCategory/filterEntityDocumentCategory',
  async (option: FilterEntityDocumentCategoryOption, { rejectWithValue }) => {
    try {
      const response = await EntityDocumentCategoryApi.findWithEntity(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityDocumentCategory = createAsyncThunk(
  'entityDocumentCategory/findOneEntityDocumentCategory',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await EntityDocumentCategoryApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityDocumentCategory = createAsyncThunk(
  'entityDocumentCategory/createEntityDocumentCategory',
  async (body: CreateEntityDocumentCategoryBody, { rejectWithValue }) => {
    try {
      const response = await EntityDocumentCategoryApi.create(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityDocumentCategory = createAsyncThunk(
  'entityDocumentCategory/updateEntityDocumentCategory',
  async (
    params: {
      id: string;
      body: UpdateEntityDocumentCategoryBody;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await EntityDocumentCategoryApi.update(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityDocumentCategory = createAsyncThunk(
  'entityDocumentCategory/removeEntityDocumentCategory',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityDocumentCategoryApi.remove(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  listAll: Array<any>;
  isInitData: boolean;
  entityDocumentSubCategoriesHash: any;
}

const initialState: IState = {
  list: [],
  listAll: [
    {
      key: 'all',
      value: 'all',
      name: 'Tất cả chứng từ',
    },
  ],
  isInitData: false,
  entityDocumentSubCategoriesHash: {},
};

const entityDocumentCategorySlice = createSlice({
  name: 'entityDocumentCategory',
  initialState,
  reducers: {},
  extraReducers: {},
});

const { reducer: entityDocumentCategoryReducer } = entityDocumentCategorySlice;

export default entityDocumentCategoryReducer;

export const selectEntityDocumentCategory = (state: RootState): IState =>
  state.entityDocumentCategory as IState;
